import { Fragment, useEffect, useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import Select from "react-select";
import { ProductCustomizationAPI } from "api";

export default function FieldsModal({ show, handleClose, customizationId }) {
  const [fields, setFields] = useState([]);
  const [fullData, setFullData] = useState({});
  const [formData, setFormData] = useState({});

  // Fetch fields from API
  useEffect(() => {
    const fetchFields = async () => {
      try {
        const res = await ProductCustomizationAPI.get({
          params: { customizationId },
        });
        const fullData = res?.data?.data;
        const apiFields = res?.data?.data?.fields || [];

        // Initialize formData with default values
        const initialData = {};
        apiFields.forEach((f) => {
          initialData[f.name] =
            f.defaultValue || (f.type === "multiSelect" ? [] : "");
        });

        setFullData(fullData);
        setFields(apiFields);
        setFormData(initialData);
      } catch (error) {
        console.error("Failed to fetch customization fields", error);
      }
    };

    if (customizationId) fetchFields();
  }, [customizationId]);

  const handleChange = (e, field) => {
    const { name, value, type, checked } = e.target || {};

    if (field.type === "multiSelect") {
      // value is an array of selected options
      setFormData({ ...formData, [field.name]: value });
    } else if (type === "checkbox") {
      setFormData({ ...formData, [name]: checked });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleMultiSelectChange = (selectedOptions, field) => {
    // store only values in formData
    const values = selectedOptions ? selectedOptions.map((o) => o.value) : [];
    setFormData({ ...formData, [field.name]: values });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // onSubmitCustomization({
    //     values: formData,
    //     fields, // includes type info
    // });
    // 🔥 pass data to parent
    // handleClose();
  };

  // Render field based on type
  const renderField = (field) => {
    const commonProps = {
      name: field.name,
      value: formData[field.name] || "",
      onChange: (e) => handleChange(e, field),
      placeholder: field.placeholder || "",
      required: field.isRequired,
    };

    switch (field.type) {
      case "text":
      case "email":
      case "currency":
        return <Form.Control type="text" {...commonProps} />;

      case "number":
        return <Form.Control type="number" {...commonProps} />;

      case "date":
        return <Form.Control type="date" {...commonProps} />;

      case "select":
      case "colorSelector":
        return (
          <Form.Select {...commonProps}>
            <option value="">Select {field.label}</option>
            {field.listValues.split("|").map((v) => (
              <option key={v} value={v}>
                {v}
              </option>
            ))}
          </Form.Select>
        );

      case "multiSelect":
        return (
          <Select
            isMulti
            options={field.listValues
              .split("|")
              .map((v) => ({ label: v, value: v }))}
            value={(formData[field.name] || []).map((v) => ({
              label: v,
              value: v,
            }))}
            onChange={(selected) => handleMultiSelectChange(selected, field)}
            placeholder={`Select ${field.label}`}
          />
        );

      case "color":
        return <Form.Control type="color" {...commonProps} />;

      default:
        return <Form.Control type="text" {...commonProps} />;
    }
  };

  // useEffect(() => {
  //     if (initialData) {
  //         setFormData(initialData);
  //     }
  // }, [initialData]);

  return (
    <Fragment>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        size="lg"
        className="custom-stitching-modal"
      >
        <Modal.Header className="border-0">
          <Modal.Title className="fw-bold">
            {fullData?.name || "Custom Stitching Details"}
          </Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={handleClose}
          ></button>
        </Modal.Header>

        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Row className="g-3">
              {fields
                ?.filter((field) => field.type !== "hidden")
                ?.map((field) => (
                  <Col md={6} key={field.id}>
                    <Form.Group controlId={field.name}>
                      <Form.Label>{field.label}</Form.Label>
                      {renderField(field)}
                    </Form.Group>
                  </Col>
                ))}
            </Row>

            <Button
              type="button"
              onClick={handleClose}
              variant="secondary"
              className="w-100 mt-3"
            >
              Close
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      <style jsx>{`
        .custom-stitching-modal .modal-content {
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
        }

        .custom-stitching-modal .modal-header {
          background-color: #f8f9fa;
        }

        .custom-stitching-modal .btn-close {
          font-size: 1.2rem;
        }
      `}</style>
    </Fragment>
  );
}
